import importStatus from '@/constant/importStatus'

const uploadDefaultState = {
  generateFromDocImportStatus: importStatus.NO_IMPORT,
  generateFromDocImportError: null,
  docToQuizUniqueRequestId: null,
  docToQuizResult: [],
  docToQuizResultModalVisible: false,
  docToQuizNewPresentationRequestId: null,
  newDocToQuizPresentationId: null,
  docToQuizGlobalImportError: false,
  docToQuizTrackGenerationDone: false,
}

export default uploadDefaultState
